import { getSearch, requestCreate, requestDelete, requestUpdate } from "../api"
import {
    ADD_IN_LIST,
    REMOVE_IN_LIST,
    RESET_SEARCH_PARAMS,
    RESET_STATE, SET_LIST, SET_LOADING, UPDATE_IN_LIST
} from "../constant-types"
import { getField, updateField } from 'vuex-map-fields'
import { defaultAddInListMutation, defaultRemoveInListMutation, defaultSetListMutation, defaultUpdateInListMutation } from "../default-method"

const getDefaultState = () => {
    return {
        list: null,
        search_params : getDefaultSearchParamsState()
    }
}

const getDefaultSearchParamsState = () => {
    return {
        filter_search_text : '',
        loading : false,
        filter_sort : [{
            column : 'customers.name',
            sort : 'asc',
            icon : ['fas', 'angle-up']
        }],
        filter_page : 1,
        filter_limit : 20
    }
}

const createForm = (rootState) => ({
    ...rootState.customerForm.rows[0],
    contacts : rootState.contactForm.rows,
    addresses : rootState.addressForm.rows,
    vehicles : rootState.vehicleForm.rows,
    pictures : rootState.pictureForm.pictures,
    new_pictures : rootState.pictureForm.new_pictures.map(np => ({ caption: np.caption, file: np.file })),
    customer_crews : rootState.customerCrewForm.rows
})

export default ({
    namespaced: true, //
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        [RESET_STATE](state) {
            // Merge rather than replace so we don't lose observers
            // https://github.com/vuejs/vuex/issues/1118
            Object.assign(state, getDefaultState())
        },
        [RESET_SEARCH_PARAMS](state) {
            state.search_params = getDefaultSearchParamsState()
        },
        [SET_LOADING](state, bool) {
            state.search_params.loading = bool
        },
        ...defaultUpdateInListMutation,
        ...defaultSetListMutation,
        ...defaultAddInListMutation,
        ...defaultRemoveInListMutation,
        updateField

    },
    // can async
    actions: {
        loadList({commit, state, getters}, payload = { resetPage : false}) {
            if (payload.resetPage) {
                commit('updateField', { path : 'search_params.filter_page', value : 1})
            }
            commit(SET_LOADING, true)
            return getSearch(
                {words: _.split(state.search_params.filter_search_text, ' '), fields : ['name']},
                [],
                [],
                state.search_params.filter_sort,
                state.search_params.filter_page,
                state.search_params.filter_limit,
                ['contacts.contactClass', 'addresses', 'pictures', 'vehicles.category', 'customerCrews.crew'],
                ['contacts', 'addresses', 'pictures', 'vehicles', 'customerCrews'],
                'customer',
                (response) => commit(SET_LIST, response),
                ()=>{},
                ()=>{commit(SET_LOADING, false)}
            )
        },
        requestCreateCustomer({commit, rootState}) {
            return requestCreate('customer', createForm(rootState), commit, ADD_IN_LIST)
        },
        requestUpdateCustomer({commit, rootState}) {
            return requestUpdate(`customer/${rootState.customerForm.rows[0].id}`, createForm(rootState), commit, UPDATE_IN_LIST)
        },
        requestDeleteCustomer({commit, state}, customer) {
            return requestDelete(`customer/${customer.id}`, {}, commit, customer.name, REMOVE_IN_LIST)
        },
        resetForm({commit}) {
            commit('customerForm/RESET_FORM', null, { root: true})
            commit('contactForm/RESET_FORM', null, { root: true})
            commit('addressForm/RESET_FORM', null, { root: true})
            commit('vehicleForm/RESET_FORM', null, { root: true})
            commit('pictureForm/RESET_FORM', null, { root: true})
            commit('customerCrewForm/RESET_FORM', null, { root: true})
        },
        setForm({commit, state}, customer) {
            commit('customerForm/SET_FORM', _.omit(customer, ['contacts', 'addresses', 'vehicles', 'pictures', 'customer_crews']), { root: true})
            commit('contactForm/SET_FORMS', customer.contacts, { root: true})
            commit('addressForm/SET_FORMS', customer.addresses, { root: true})
            commit('vehicleForm/SET_FORMS', customer.vehicles, { root: true})
            commit('pictureForm/SET_FORMS', customer.pictures, { root: true})
            commit('customerCrewForm/SET_FORMS', customer.customer_crews, { root: true})
        }

    },
    // call variable with custom display
    getters: {
        getField
    },
})
